module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Right-2-776051ed4022deef084011c7f63ccc44.svg";